/**
 * Client for the Google-auth commenter flow + comment CRUD.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT
 * URLS, THIS BREAKS THE AUTH (see Emergent Google Auth playbook).
 */
import { api } from "./api";

const AUTH_PORTAL = "https://auth.emergentagent.com/";

/** Kick off Google sign-in. Always redirects back to whatever page the
 * user is currently on so they land back next to the post they wanted
 * to comment under. */
export function startCommenterLogin() {
  const redirectUrl = window.location.origin + window.location.pathname + window.location.search;
  window.location.href = `${AUTH_PORTAL}?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function exchangeSessionId(sessionId) {
  const r = await api.post("/commenter/session", { session_id: sessionId });
  return r.data;
}

export async function fetchCommenterMe() {
  const r = await api.get("/commenter/me");
  return r.data; // null if not signed in
}

export async function commenterLogout() {
  await api.post("/commenter/logout");
}

export async function listComments(postId) {
  const r = await api.get(`/posts/${postId}/comments`);
  return r.data || [];
}

export async function postComment(postId, body, parentId, imageUrl) {
  const payload = { body };
  if (parentId) payload.parent_id = parentId;
  if (imageUrl) payload.image_url = imageUrl;
  const r = await api.post(`/posts/${postId}/comments`, payload);
  return r.data;
}

/** Uploads a "data:image/jpeg;base64,..." image (e.g. a Lineup Builder
 *  export) so it can be attached to a comment via `postComment`'s
 *  `imageUrl` param. Requires the caller to already be signed in. */
export async function uploadCommentImage(dataUrl) {
  const r = await api.post("/comments/upload-image", { image: dataUrl });
  return r.data.url;
}

/** {id, title}[] of published posts with image-comments turned on —
 *  powers the Lineup Builder's "Post to Match Comments" dropdown. */
export async function listImageEligiblePosts() {
  const r = await api.get("/posts/comment-image-eligible");
  return r.data || [];
}

export async function deleteOwnComment(commentId) {
  await api.delete(`/comments/${commentId}`);
}

export async function editOwnComment(commentId, body) {
  const r = await api.patch(`/comments/${commentId}`, { body });
  return r.data;
}

/** Anonymous thumbs-up. No auth — anyone can call this. The server
 *  rate-limits per IP. We use localStorage on top of that as a UX hint
 *  so the button visually stays "pressed" on the same browser. */
export async function likeComment(commentId) {
  const r = await api.post(`/comments/${commentId}/like`);
  return r.data; // { id, likes }
}
